import gql from 'graphql-tag'
import styled from 'styled-components'
import { ChoiceQuestion_ExamSurveyAnswerFragment } from 'generated/graphql'
import LevelRatingQuestionLabelLayout from '../LevelRatingQuestionLabelLayout'
import ChoiceAnswerItemDesktop from './ChoiceAnswerItem.desktop'

gql`
  fragment ChoiceQuestion_examSurveyAnswer on ExamSurveyAnswer {
    seq
    content
    id
  }
`

interface ChoiceQuestionDesktopProps {
  questioonLabel: string
  questionSeq: number
  questionId: string
  answerList: ChoiceQuestion_ExamSurveyAnswerFragment[]
}

const ChoiceQuestionDesktop = ({
  questioonLabel,
  questionSeq,
  questionId,
  answerList,
}: ChoiceQuestionDesktopProps) => {
  return (
    <StyledWrapper>
      <LevelRatingQuestionLabelLayout label={questioonLabel}>
        <div className="answer-list-box">
          {answerList.map((answer, index) => {
            return (
              <ChoiceAnswerItemDesktop
                label={answer.content}
                key={`${answer.id}-${index}`}
                id={answer.id}
                questionId={questionId}
                questionSeq={questionSeq}
              />
            )
          })}
        </div>
      </LevelRatingQuestionLabelLayout>
    </StyledWrapper>
  )
}

export default ChoiceQuestionDesktop

const StyledWrapper = styled.div`
  margin-bottom: 44px;

  .answer-list-box {
    display: flex;
    align-items: center;
    column-gap: 40px;
    row-gap: 12px;
    flex-wrap: wrap;
  }
`
